export const ClosingLineWidgetId = 'ClosingLineWidget';

export enum ClosingLineWidgetAttributes {
  INFO_LINE = 'infoLine',
  LIST_NORMAL = 'listNormal',
  LIST_IMPORTANT = 'listImportant',
}
